import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async findPorProgramaUniversidadId(programaUniversidadId) {
    return await axiosIns.get(
      obtenerUrlAPIPagos(`inscripcion-programa-universidad-excel/programa-universidad/${programaUniversidadId}`),
      {
        responseType: 'arraybuffer',
      },
    );
  },
  async findPorCodigosProgramasUniversidad(datos) {
    return await axiosIns.post(
      obtenerUrlAPIPagos('inscripcion-programa-universidad-excel/programa-universidad/codigos-programas-universidad'),
      datos,
      {
        responseType: 'arraybuffer',
      },
    );
  },
};
